import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { AsyncPipe } from '@angular/common';
import { Button } from "primeng/button";
import {PopoverModule} from 'primeng/popover';
import { RouterLink } from '@angular/router';
import { ThemeService } from '../../../core/services/theme.service';
import { UserStateService } from '../../../core/services/user-state.service';
import { RolesService } from '../../../core/auth/roles.service';

@Component({
  selector: 'app-user-menu',
  imports: [AsyncPipe, Button, PopoverModule, RouterLink],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMenuComponent implements OnInit {
 constructor(public auth: AuthService) {}
 // Theme service - centralized theme management
  themeService = inject(ThemeService);
  userStateService = inject(UserStateService);
  rolesService = inject(RolesService);
  // Alias for the already-computed highestRole signal from RolesService
  readonly currentPlan = this.rolesService.highestRole;

  ngOnInit(): void {
    this.auth.user$.subscribe();
  }

  login() {
    this.auth.loginWithRedirect({
      appState: { target: '/dashboard' }
    });
  }

  logout() {
    // Clear user state before logging out
    this.userStateService.clearState();
    this.auth.logout({ logoutParams: { returnTo: window.location.origin } });
  }

   toggleTheme(): void {
    this.themeService.toggleTheme();
  }
}
